import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section aria-labelledby="home-faq" className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <h2 id="home-faq" className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于引用、提交线索、公告更新与防诈骗，这里先回答最常被问到的几个问题。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600 cursor-pointer"
          >
            查看全部问答
            <span className="flex h-4 w-4 items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 4)} />
        </div>
      </div>
    </section>
  );
}